import { Component, Input, Output, EventEmitter } from '@angular/core';
import { OrderCardNumber } from 'app/tracking-page/store/tracking-page-numbers';
import {
  TrackingPageOrderItemsFrame,
  TrackingPageText
} from '../../tracking-page.model';

@Component({
  selector: 'app-tracking-page-order',
  templateUrl: './tracking-page-order.component.html',
  styleUrls: ['./tracking-page-order.component.scss']
})
export class TrackingPageOrderComponent {
  @Input() order: OrderCardNumber;
  @Input() selectedId: any;
  @Output() selectBlock = new EventEmitter();
  @Input() orderItemsFrame: TrackingPageOrderItemsFrame;
  @Input() orderLastUpdated: TrackingPageText;
  @Input() orderLastUpdatedOn: boolean;
  @Input() orderNumber: TrackingPageText;
  @Input() orderNumberOn: boolean;
  @Input() orderStatus: TrackingPageText;
  @Input() orderStatusOn: boolean;
  @Input() notYetShippedItemsTitle: TrackingPageText;

  constructor() {}

  get orderLastUpdatedStyles() {
    const { fontSize, alignment } = this.orderLastUpdated;
    return {
      'fontSize.px': fontSize,
      'text-align': alignment
    };
  }
  get orderNumberStyles() {
    const { fontSize, alignment } = this.orderNumber;
    return {
      'fontSize.px': fontSize,
      'text-align': alignment
    };
  }
  get orderStatusStyles() {
    const { fontSize, alignment } = this.orderStatus;
    return {
      'fontSize.px': fontSize,
      'text-align': alignment
    };
  }
  get notYetShippedItemsTitleStyle() {
    const { fontSize, alignment } = this.notYetShippedItemsTitle;
    return {
      'fontSize.px': fontSize,
      'text-align': alignment
    };
  }
  selectItemBlock(id: string, event: any) {
    event.stopPropagation();
    this.selectBlock.emit(id);
  }
}
